export const colors = {
  primary: '#002F69',
  secondary: '#FFFFFF',
  accent: '#000000'
};